module.exports = __webpack_public_path__ + "static/media/filter.2ddeb3df.svg";